// - 常用host配置 -- 命名按照模块或域名来定义
const HOSTS = {
    dev: {
        openapi: 'devinvest.gushi.com',
        payRead: 'devsec.gushi.com',
        privi: 'devprivi.gushi.com/privi',
        tougu: 'devtougu.gushi.com',
        dtlog: 'dev.gushi.com',
        sec1: 'devsec.gushi.com'
    },
    sit: {
        openapi: 'testinvest.gushi.com',
        payRead: 'testsec.gushi.com',
        privi: 'testprivi.gushi.com',
        tougu: 'testtougu.gushi.com',
        dtlog: 'test.gushi.com',
        sec1: '"testsec.gushi.com'
    },
    uat : {
        openapi: 'uatinvest.gushi.com',
        payRead: 'uatsec.gushi.com',
        privi: 'uatprivi.gushi.com',
        tougu: 'uattougu.gushi.com',
        dtlog: 'https://dtlog.gushi.com/',
        sec1: 'uatsec.gushi.com'
    },
    prd: {
        openapi: 'invest.gushi.com',
        payRead: 'sec.gushi.com',
        privi: 'privi.gushi.com',
        tougu: 'tougu.gushi.com',
        dtlog: 'https://dtlog.gushi.com/',
        sec1: 'sec.gushi.com'
    }
}
// - 请求路径汇总
const PATHS = {
    getConfig: '/edu-web/oauth2-auth/qryHome', // 首页配置查询
    getLivingData:'/edu-web/newLive/fistPageGetLive',//直播内容
    getBannerNew: '/activities/banner/getBannerList',
    getBanner: '/edu-web/oauth2-api/qryBanner', // 首页banner图查询
    getAdviser: '/edu-web/oauth2-api/qryAdviser', // 投顾老师查询
    getCourse: '/edu-web/oauth2-api/qryCourse', // 课程查询
    getCourseCatalog: '/edu-web/oauth2-api/qryCourseCatalog', // 单个课程目录查询
    getCourseLevel: '/edu-web/oauth2-api/qryRecommendCourseByCourseId', // 单个进阶课程查询
    getProductInfo: '/incr/productAction/getProductInfoForWap', // 产品信息查询
    getProductPay: '/',
    getDynamic: '/edu-web/oauth2-api/getHotDynamic', // 获取最新动态
    getCourseClassify: '/edu-web/api/auth/qryDict', // 获取首页课程分类
    aiLiveList: '/jlls/msg/getMsgList',  // AI智投直播列表
    columnSubscribe: '/edu-web/oauth2-api/qrySpecialColumn',  // 查看是否订阅专栏和老师详情(是否订阅和专家团查询合并成一个接口)
    columnSubscribeStatus: '/edu-web/oauth2-api/column/get-user-column-user', // 查看是否订阅专栏
    columnSubscribeAdd: '/edu-web/oauth2-api/column/add-column-user', // 专栏订阅
    columnSubscribeClose: '/edu-web/oauth2-api/column/close-column-user', // 专栏取消
    getUserClassStudyHistory: '/edu-web/oauth2-api/qryAllLearningHistory', // 用户学习记录查询
    getCourseTag: '/edu-web/oauth2-api/qryTags', // 获取分类下的课程标签
    burialPoint: '/burypoint/postBuryPointInfo',
    getSpecialDynamic: '/edu-web/oauth2-api/getSpecialDynamic', // 每日复盘专栏视频查询
    qryUserStudyPlan: '/edu-web/oauth2-api/qryLearningPlan', // 查询用户学习计划
    addStudyPlan: '/edu-web/oauth2-api/addLearningPlan', // 新增学习计划
    qryRecommendCourse: '/edu-web/oauth2-api/qryRecommendCourse', // 查询推荐课程
    addLearningHistory: '/edu-web/oauth2-api/addLearningHistory', // 用户学习历史添加
    getNewestSpecialDynamic: '/edu-web/oauth2-api/getNewestSpecialDynamic', // 最新解读
};
const API = {
    // ========== 公共方法 ==========
    /**
     * 获取请求地址
     * @param {String} type 类型
     * @param {Boolean} forcePrd 强制使用生产配置
     */
    getAjaxHost(type = 'default', forcePrd) {
        // let nowUrl = location.href;
        let hostname = '';
        let protocol = location.protocol;
        let env = 'prd';
        let resultUrl = '';
        hostname = location.hostname;
        // - 环境判断
        
        if (forcePrd) {
            env = 'prd';
        } else if (/localhost|188\.180|dev[^.]*\.gushi\.com/.test(hostname)) {
            env = 'sit';
        } else if (/test[^.]*\.gushi\.com/.test(hostname)) {
            env = 'sit';
        } else if(/uat[^.]*\.gushi\.com/.test(hostname)) {
            env = 'uat';
        }  else {
            env = 'prd';
        }
        // - 配置获取
        try {
            resultUrl = HOSTS[env][type];
        } catch (error) {
            // resultUrl = 'sec.gushi.com';
        }
        return /^http/.test(resultUrl) ? resultUrl : (protocol + '//' + resultUrl);
    },
    /**
     * 获取请求路径
     * @param {String} name 名称
     */
    getAjaxPath(name) {
        return PATHS[name] || '';
    },
    /**
     * 获取请求路径
     * @param {String} type
     * @param {String} name
     * @param {Boolean} forcePrd
     */
    getAjaxUrl(type, name, forcePrd) {
        let host = API.getAjaxHost(type, forcePrd);
        let path = API.getAjaxPath(name);
        // console.log(host)
        if (!path) {
            console.log('获取请求路径出错');
        }
        return host + path;
    },
}
export default API;



// WEBPACK FOOTER //
// ./src/fetch/newApi.js